module.exports = __webpack_public_path__ + "img/Warehouse03.eab468bf.jpg";